var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2464_60072)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.6001,
    y: 5.6001,
    width: 20.8,
    height: 20.8,
    fill: "#39455E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7688 8.51367H11.2313C9.70899 8.51367 8.47046 9.7522 8.47046 11.2745V20.812C8.47046 22.3343 9.70899 23.5732 11.2313 23.5732H20.7688C22.2911 23.5732 23.53 22.3347 23.53 20.812V11.2745C23.53 9.7522 22.2914 8.51367 20.7688 8.51367ZM16 21.0009C13.2666 21.0009 11.0427 18.777 11.0427 16.0433C11.0427 13.3099 13.2666 11.0859 16 11.0859C18.7338 11.0859 20.9577 13.3099 20.9577 16.0433C20.9577 18.7766 18.7334 21.0009 16 21.0009ZM21.1171 12.1109C20.47 12.1109 19.9438 11.5847 19.9438 10.938C19.9438 10.2913 20.47 9.76504 21.1171 9.76504C21.7638 9.76504 22.29 10.2913 22.29 10.938C22.29 11.5847 21.7638 12.1109 21.1171 12.1109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.1807C14.4221 13.1807 13.1372 14.4648 13.1372 16.0428C13.1372 17.6214 14.4221 18.9059 16 18.9059C17.5787 18.9059 18.8625 17.6214 18.8625 16.0428C18.8625 14.4652 17.5783 13.1807 16 13.1807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.1638 0 0 7.1638 0 16C0 24.8362 7.1638 32 16 32C24.8362 32 32 24.8362 32 16C32 7.1638 24.8362 0 16 0ZM25.6245 20.8119C25.6245 23.4896 23.4465 25.6676 20.7687 25.6676H11.2313C8.55384 25.6676 6.37554 23.4896 6.37554 20.8119V11.2744C6.37554 8.59698 8.55384 6.41868 11.2313 6.41868H20.7687C23.4465 6.41868 25.6245 8.59698 25.6245 11.2744V20.8119Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2464_60072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bed3d33009010c7bd46273ef46e1dbcc.svg";
export { ForwardRef as ReactComponent };